import { Currency } from 'dinero.js'

export interface CurrencyRate {
  code: Currency
  name: string
  symbol: string
  rate: number
}

export abstract class CurrenciesRepository {
  abstract readAll(): Promise<CurrencyRate[]>
}
